export function splitNoteBody(body: string): { title: string; text: string } {
  const [title = "", ...rest] = body.split("\n");
  return { title, text: rest.join("\n") };
}

export function joinNoteBody(title: string, text: string, limit = 100_000): string {
  const cleanTitle = title.trim();
  return `${cleanTitle}${cleanTitle && text ? "\n" : ""}${text}`.slice(0, limit);
}

export function selectedNoteText(value: string, limit = 100_000): string { return value.trim().slice(0, limit); }
